import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RequestParams, ResponseCatalog } from 'Models'
import { SmsRuleModel, SmsLimitModel, SmsStatsModel } from 'Pages/som'
import { Id } from 'Types/aliases'

export const smsSettingsApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<SmsRuleModel>>(urls.som.sms_rule, {
			params,
		})
		return res.data
	},
	createOne: async (data: SmsRuleModel) => {
		const res = await axiosDS().post<SmsRuleModel>(urls.som.sms_rule, { data })
		return res.data
	},
	updateOne: async (id: Id, data?: SmsRuleModel) => {
		const res = await axiosDS().patch<SmsRuleModel>(`${urls.som.sms_rule}/${id}`, { data })
		return res.data
	},
	deleteOne: async (id: Id) => {
		const res = await axiosDS().delete(`${urls.som.sms_rule}/${id}`)
		return res.data
	},

	getSmsStats: async () => {
		const res = await axiosDS().get<Record<'parts' | 'sms', SmsStatsModel>>(urls.som.sms_statistic)
		return res.data
	},

	getSmsLimit: async () => {
		const res = await axiosDS().get<{ data: SmsLimitModel }>(urls.som.sms_sender)
		return res.data.data
	},
	updateSmsLimit: async (data?: SmsLimitModel) => {
		const res = await axiosDS().patch<{ key: string; data: SmsRuleModel }>(urls.som.sms_sender, {
			data: { data },
		})
		return res.data
	},
}
